/* CohesiveNow — personalisation add-on (v2).

   Background: until 2026-08-04 `Personalisation` was a *variant option*. Now it
   is a service SKU (`personalisation`) with Standard ₹600 and Gold Foil ₹1,500
   variants. Charge is per distinct personalised product. See
   docs/product-inventory/PERSONALISATION-V2-SPEC.md.

   This script:

   1. Renders the Personalisation pill row on the PDP.
   2. Builds a single live preview box above the personalisation fields.
   3. Polishes field labels, char counters, and the gold-foil control.
   4. Keeps Standard / Gold Foil fee lines in the cart in step with the cart. */
(function () {
  'use strict';

  var feeConfig = window.cnPersonalisation || {};
  var FEE_VARIANT_ID = Number(feeConfig.feeVariantId) || null;
  var FEE_GOLD_VARIANT_ID = Number(feeConfig.feeGoldVariantId) || null;
  var FEE_LABEL = feeConfig.feeLabel ? ('+' + feeConfig.feeLabel) : '+₹600';
  var FEE_GOLD_LABEL = feeConfig.feeGoldLabel ? ('+' + feeConfig.feeGoldLabel) : '+₹1,500';

  var NAMES_LABEL = 'Names to foil';
  var GREETING_LABEL = 'Greeting';
  var FONT_LABEL = 'Font';
  var ADDITIONAL_LABEL = 'Additional info';
  var GOLD_LABEL = 'Gold foil';
  var FOR_LABEL = 'For';
  var FOIL_LABEL = 'To foil';
  var OPTION_NAME = 'Personalisation';
  var VALUE_OFF = 'Non-Personalised';
  var VALUE_ON = 'Personalised';
  var CHOICES = [
    { value: VALUE_OFF, label: 'No personalisation' },
    { value: VALUE_ON, label: 'Personalised · ' + FEE_LABEL }
  ];

  var FEE_HANDLE = feeConfig.feeProductHandle || '';
  var ROW_CLASS = 'cn-pers-row';
  var PREVIEW_CLASS = 'cn-pers-preview';
  var INTEGRITY_ERROR_ID = 'cn-personalisation-integrity-error';
  var NAMES_MAX = 150;
  var ADDITIONAL_MAX = 200;
  var ADDITIONAL_ROWS = 2;
  var FONT_SAMPLE = 'Aanya & Veer';
  var GOLD_TAG_COPY = 'Make it gold foil';   /* the control — an invitation */
  var PLATE_FOIL_COPY = 'Gold foiled';       /* the plate badge — a state */
  var GOLD_TAG_AMOUNT = '+₹1,000';
  /* Chips below this width would scroll options off-screen, so the same
     choices render as a dropdown instead. Matches the CSS breakpoint. */
  var FONT_CHIPS_MQ = '(min-width: 600px)';
  var NO_GREETING = 'NO GREETINGS';
  var SAMPLE_NAME = 'Your names';
  var SAMPLE_ADDITIONAL = 'Additional text (if any)';
  var OPTION_NAMES = ['personalisation', 'personalization'];
  var FIELD_MARK = 'data-cn-pers-field';

  /* Money-envelope-only: show Greeting + Additional info controls.
     This is intentionally read from each product form rather than a page-wide
     global. Quick-add fetches a second PDP into a modal, so a global belongs to
     the page that happened to load first—not necessarily to that product. */
  function showGreetingAdditional(scope) {
    var value = scope && scope.getAttribute && scope.getAttribute('data-cn-show-greeting-additional');
    if (value === 'true') return true;
    if (value === 'false') return false;

    /* Compatibility fallback for any older, injected product markup. It fails
       open as the pre-existing implementation did, rather than hiding fields
       merely because that markup has not yet been updated. */
    return typeof window.cnPersonalisationShowGreetingAdditional === 'boolean'
      ? window.cnPersonalisationShowGreetingAdditional
      : true;
  }

  var FONT_FACES = {
    'AGaramond Regular': 'agaramond-regular',
    'AGaramond Italic': 'agaramond',
    'Bickham Script': 'bickham',
    'Candlescript': 'candlescript',
    'Cataneo BT': 'cataneo'
  };

  /* Only the licensed faces are offered to shoppers: Adobe Garamond Pro and
     Bickham Script Pro 3, both served by the Adobe Fonts kit. Candlescript and
     Cataneo BT are unlicensed stand-ins — they would render in a substitute
     face, so the shopper would not get what the chip showed them. Any face
     dropped here stays valid in the <select> for existing carts. */
  var FONTS_OFFERED = ['AGaramond Regular', 'AGaramond Italic', 'Bickham Script'];

  /* Shopper-facing font labels (spec). Stored values stay the face names. */
  var FONT_SHOPPER = {
    'AGaramond Regular': 'Agaramond',
    'AGaramond Italic': 'Agaramond Italic',
    'Bickham Script': 'Becoming',
    'Candlescript': 'Candle Script',
    'Cataneo BT': 'Get a Neo'
  };

  var CART_PROP_LABELS = {
    'Names to foil': 'Name',
    'Additional info': 'Note',
    'Gold foil': 'Gold foil',
    'Greeting': 'Greeting',
    'Font': 'Font',
    'For': 'For',
    'To foil': 'Details'
  };

  var busy = false;
  var ensuring = false;
  var ensureTimer = null;
  var uidSeq = 0;

  function nextUid() {
    uidSeq += 1;
    return 'cn-pers-' + uidSeq + '-' + Date.now().toString(36);
  }

  function namesField(root) {
    return (root || document).querySelector('input[name="properties[' + NAMES_LABEL + ']"]');
  }
  function greetingField(root) {
    return (root || document).querySelector('select[name="properties[' + GREETING_LABEL + ']"]');
  }
  function fontField(root) {
    return (root || document).querySelector('select[name="properties[' + FONT_LABEL + ']"]');
  }
  function additionalField(root) {
    return (root || document).querySelector('textarea[name="properties[' + ADDITIONAL_LABEL + ']"], input[name="properties[' + ADDITIONAL_LABEL + ']"]');
  }
  function goldField(root) {
    return (root || document).querySelector('input[name="properties[' + GOLD_LABEL + ']"]');
  }

  function propField(root, label) {
    return (root || document).querySelector(
      'input[name="properties[' + label + ']"], select[name="properties[' + label + ']"], textarea[name="properties[' + label + ']"]'
    );
  }

  function fieldWrap(el) {
    return el && el.closest('.product__line_item_property, [data-cn-pers-field]');
  }

  /* ---------- product page: the pill row ---------- */

  function buildRow(scope) {
    var uid = nextUid();
    var fieldset = document.createElement('fieldset');
    fieldset.className = 'js product-form__input ' + ROW_CLASS;
    fieldset.style.marginTop = '1.5rem';

    var legend = document.createElement('legend');
    legend.className = 'form__label';
    legend.textContent = OPTION_NAME;
    fieldset.appendChild(legend);

    var native = scope.querySelector('.product-variant-grid');
    var grid = document.createElement('div');
    grid.className = native ? native.className : 'product-variant-grid';
    grid.classList.remove('no-js-hidden');

    CHOICES.forEach(function (choice, i) {
      var item = document.createElement('div');
      item.className = 'product-variant-item';
      item.setAttribute('tabindex', '0');

      var id = uid + '-' + i;
      var input = document.createElement('input');
      input.type = 'radio';
      input.setAttribute('tabindex', '-1');
      input.id = id;
      input.name = OPTION_NAME;
      input.value = choice.value;
      if (i === 0) input.checked = true;

      var label = document.createElement('label');
      label.className = 'subtitle';
      label.setAttribute('for', id);
      label.textContent = choice.label;

      item.appendChild(input);
      item.appendChild(label);
      grid.appendChild(item);
    });

    fieldset.appendChild(grid);
    return fieldset;
  }

  /* Gate foiling fields behind the Personalisation pills. Lives here (not only
     in the product-template custom-liquid) so quick-add modals on the homepage
     get the same behaviour — that modal is injected outside <main> and never
     includes the cn_pers_logic section. */
  function isNonPersonalised(value) {
    return /^non[-\s]?person/i.test((value || '').trim());
  }

  function readPersState(root) {
    var has = false;
    var on = false;
    root.querySelectorAll('input[type=radio]').forEach(function (radio) {
      var name = (radio.name || '').trim().toLowerCase();
      if (OPTION_NAMES.indexOf(name) === -1) return;
      has = true;
      if (radio.checked) on = !isNonPersonalised(radio.value);
    });
    return { has: has, on: on };
  }

  function setRequired(root, selector, on) {
    var el = root.querySelector(selector);
    if (!el) return;
    if (on) el.setAttribute('required', 'required');
    else el.removeAttribute('required');
  }

  function gateFields(root) {
    var state = readPersState(root);
    var show = state.has ? state.on : true;
    var requireCore = state.has && state.on;
    var allowGreetingAdditional = showGreetingAdditional(root);

    root.querySelectorAll('.product__line_item_property, [' + FIELD_MARK + '], .' + PREVIEW_CLASS + ', .cn-pers-fee-note').forEach(function (field) {
      if (field.classList.contains('cn-pers-fee-note')) {
        field.style.display = show ? '' : 'none';
        return;
      }

      var isGreeting = !!field.querySelector('select[name="properties[' + GREETING_LABEL + ']"]');
      if (!isGreeting) {
        isGreeting = !!field.querySelector('input[name="properties[' + GREETING_LABEL + ']"]');
      }
      var isAdditional = !!field.querySelector('textarea[name="properties[' + ADDITIONAL_LABEL + ']"], input[name="properties[' + ADDITIONAL_LABEL + ']"]');
      var finalShow = show;
      if (!allowGreetingAdditional && (isGreeting || isAdditional)) {
        finalShow = false;
      }

      field.setAttribute(FIELD_MARK, '1');
      if (!field.classList.contains(PREVIEW_CLASS) && !field.classList.contains(ROW_CLASS)) {
        field.classList.toggle('product__line_item_property', finalShow);
      }
      field.style.display = finalShow ? '' : 'none';

      var block = field.closest('.product-block-line_item_property__wrapper');
      if (block) block.style.display = finalShow ? '' : 'none';

      field.querySelectorAll('input, textarea, select').forEach(function (el) {
        el.disabled = !finalShow;
        if (!finalShow && el.value && el.type !== 'hidden' && el.type !== 'checkbox') {
          if (el.tagName === 'SELECT') el.selectedIndex = 0;
          else el.value = '';
        }
        if (!finalShow && el.type === 'checkbox') {
          el.checked = false;
          var box = el.closest('form-checkbox');
          el.value = box ? (box.getAttribute('data-unchecked') || 'No') : 'No';
        }
      });
    });

    setRequired(root, 'input[name="properties[' + NAMES_LABEL + ']"]', requireCore);
    setRequired(root, 'select[name="properties[' + GREETING_LABEL + ']"]', requireCore && allowGreetingAdditional);
    setRequired(root, 'select[name="properties[' + FONT_LABEL + ']"]', requireCore);
    root.querySelectorAll('.cn-pers-grow').forEach(autoGrow);
    syncGoldTag(root);
    syncFeeNote(root);
    syncDispatchBadge(root);
  }

  /* PDP truck line: swap dispatch window with the personalisation pills.
     Always keeps "Ships across India". No-JS fallback in product.json is the
     non-personalised (2–4) line. */
  var DISPATCH_OFF = 'Dispatched within 2–4 working days';
  var DISPATCH_ON = 'Dispatched within 7–10 working days';
  var DISPATCH_SUFFIX = 'Ships across India';
  var DISPATCH_MARK = 'data-cn-dispatch-badge';

  function dispatchLine(on) {
    return (on ? DISPATCH_ON : DISPATCH_OFF) + ' · ' + DISPATCH_SUFFIX;
  }

  function findDispatchBadge(scope) {
    var marked = scope.querySelector('[' + DISPATCH_MARK + ']');
    if (marked) return marked;
    var nodes = scope.querySelectorAll('.product__text-wrapper .product__text');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = (el.textContent || '').toLowerCase();
      if (
        t.indexOf('working days') === -1 &&
        t.indexOf('ships across india') === -1 &&
        t.indexOf('shipped across india') === -1 &&
        t.indexOf('dispatch') === -1
      ) {
        continue;
      }
      el.setAttribute(DISPATCH_MARK, '1');
      return el;
    }
    return null;
  }

  function syncDispatchBadge(scope) {
    var el = findDispatchBadge(scope);
    if (!el) return;
    var state = readPersState(scope);
    var on = state.has ? state.on : false;
    var next = dispatchLine(on);
    var target = el.querySelector('p') || el;
    if ((target.textContent || '').trim() === next) return;
    target.textContent = next;
  }

  function scheduleEnsureRow() {
    if (ensureTimer) clearTimeout(ensureTimer);
    ensureTimer = setTimeout(function () {
      ensureTimer = null;
      ensureRow();
    }, 50);
  }

  function ensureRow() {
    /* Re-entrancy guard: inserting the preview / rewriting labels mutates the
       DOM under our own childList observer. Without this lock, refreshPreview's
       textContent writes re-enter forever and the PDP never reaches
       DOMContentLoaded (page looks hung). */
    if (ensuring) return;
    ensuring = true;
    try {
      document.querySelectorAll('.product__info-wrapper').forEach(function (scope) {
        if (!namesField(scope)) return;
        var needsPreview = !scope.querySelector('.' + PREVIEW_CLASS);
        if (!scope.querySelector('.' + ROW_CLASS)) {
          var picker = scope.querySelector('variant-radios, variant-selects, .product__variant_picker_container');
          if (picker && picker.parentNode) {
            picker.parentNode.insertBefore(buildRow(scope), picker.nextSibling);
          } else {
            var anchor = namesField(scope).closest('.product__line_item_property');
            if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(buildRow(scope), anchor);
          }
        }
        ensureFieldRow(scope);
        ensurePreview(scope);
        polishFields(scope);
        gateFields(scope);
        if (needsPreview && readPersState(scope).on) refreshPreview(scope);
      });
    } finally {
      ensuring = false;
    }
  }

  /* ---------- compact layout: greeting + name on one row ----------

     Greeting is a short select and never earned full width. The row is a
     wrapping flex — NOT a direction switch — because a `flex: 0 0 190px`
     basis flips to meaning *height* under `flex-direction: column` and opens
     a 190px hole above the name field on narrow screens. */

  function ensureFieldRow(scope) {
    var nameWrap = fieldWrap(namesField(scope));
    if (!nameWrap || nameWrap.closest('.cn-pers-fieldrow')) return;
    var greetWrap = showGreetingAdditional(scope) ? fieldWrap(greetingField(scope)) : null;

    var first = nameWrap;
    if (greetWrap && (greetWrap.compareDocumentPosition(nameWrap) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      first = greetWrap;
    }
    if (!first.parentNode) return;

    var row = document.createElement('div');
    row.className = 'cn-pers-fieldrow';
    first.parentNode.insertBefore(row, first);

    if (greetWrap) {
      greetWrap.classList.add('cn-pers-col', 'cn-pers-col--greeting');
      row.appendChild(greetWrap);
    }
    nameWrap.classList.add('cn-pers-col', 'cn-pers-col--name');
    row.appendChild(nameWrap);
  }

  /* ---------- font: chips (wide) / dropdown (narrow) ----------

     The native <select> stays in the DOM and in the form as the value carrier,
     but is hidden from sight AND from assistive tech; our control is the real
     control, with proper roles and keyboard support. It must NOT be aria-hidden:
     base.css:3586 sets `[aria-hidden="true"] { pointer-events: none }`, which
     is exactly right — an aria-hidden element must not be interactive. */

  var fontMq = window.matchMedia ? window.matchMedia(FONT_CHIPS_MQ) : null;

  function fontOptions(select) {
    return Array.prototype.map.call(select.options, function (opt) {
      return {
        value: opt.value,
        label: FONT_SHOPPER[opt.value] || opt.textContent || opt.value,
        face: FONT_FACES[opt.value] || 'agaramond'
      };
    }).filter(function (o) {
      return FONTS_OFFERED.indexOf(o.value) > -1;
    });
  }

  /* If the select still defaults to a face we no longer offer, move it to the
     first offered one so preview and cart never disagree. */
  function normaliseFontValue(select) {
    if (!select || FONTS_OFFERED.indexOf(select.value) > -1) return false;
    var want = FONTS_OFFERED[0];
    var has = Array.prototype.some.call(select.options, function (o) { return o.value === want; });
    if (!has) return false;
    select.value = want;
    return true;
  }

  function sampleText(scope) {
    var el = namesField(scope);
    var typed = el && el.value ? String(el.value).trim() : '';
    return typed || FONT_SAMPLE;
  }

  function buildFontControl(scope) {
    var select = fontField(scope);
    if (!select) return;
    var wrap = fieldWrap(select);
    if (!wrap) return;

    wrap.classList.add('cn-pers-fontfield');
    select.setAttribute('aria-hidden', 'true');
    select.setAttribute('tabindex', '-1');
    if (normaliseFontValue(select)) {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var ctl = wrap.querySelector('.cn-pers-fontctl');
    if (!ctl) {
      ctl = document.createElement('div');
      ctl.className = 'cn-pers-fontctl';
      wrap.appendChild(ctl);
    }

    var chips = !fontMq || fontMq.matches;
    if (ctl.getAttribute('data-mode') === (chips ? 'chips' : 'menu')) return;
    ctl.setAttribute('data-mode', chips ? 'chips' : 'menu');
    ctl.innerHTML = '';

    var opts = fontOptions(select);

    if (chips) {
      var strip = document.createElement('div');
      strip.className = 'cn-pers-chips';
      strip.setAttribute('role', 'radiogroup');
      strip.setAttribute('aria-label', FONT_LABEL);
      opts.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cn-pers-chip';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', 'false');
        b.setAttribute('data-font', o.value);
        b.innerHTML = '<span class="cn-pers-chip__sample" data-font-face="' + o.face + '"></span>' +
          '<span class="cn-pers-chip__label"></span>';
        b.querySelector('.cn-pers-chip__label').textContent = o.label;
        strip.appendChild(b);
      });
      ctl.appendChild(strip);
    } else {
      var menu = document.createElement('div');
      menu.className = 'cn-pers-fontmenu';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cn-pers-fontmenu__btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', FONT_LABEL);
      btn.innerHTML = '<span class="cn-pers-fontmenu__sample"></span>' +
        '<span class="cn-pers-fontmenu__label"></span>' +
        '<span class="cn-pers-fontmenu__caret" aria-hidden="true"></span>';
      menu.appendChild(btn);

      var list = document.createElement('div');
      list.className = 'cn-pers-fontmenu__list';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', FONT_LABEL);
      opts.forEach(function (o) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'cn-pers-fontmenu__opt';
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        item.setAttribute('data-font', o.value);
        item.innerHTML = '<span class="cn-pers-chip__sample" data-font-face="' + o.face + '"></span>' +
          '<span class="cn-pers-chip__label"></span>';
        item.querySelector('.cn-pers-chip__label').textContent = o.label;
        list.appendChild(item);
      });
      menu.appendChild(list);
      ctl.appendChild(menu);
    }
  }

  function syncFontControl(scope) {
    var select = fontField(scope);
    if (!select) return;
    var wrap = fieldWrap(select);
    if (!wrap) return;
    var current = select.value;
    var sample = sampleText(scope);

    wrap.querySelectorAll('.cn-pers-chip__sample, .cn-pers-fontmenu__sample').forEach(function (el) {
      el.textContent = sample;
    });
    wrap.querySelectorAll('[data-font]').forEach(function (el) {
      var on = el.getAttribute('data-font') === current;
      if (el.getAttribute('role') === 'option') el.setAttribute('aria-selected', String(on));
      else {
        el.setAttribute('aria-checked', String(on));
        /* Roving tabindex: the group is one tab stop, arrows move within it. */
        el.tabIndex = on ? 0 : -1;
      }
    });

    var btn = wrap.querySelector('.cn-pers-fontmenu__btn');
    if (btn) {
      var face = FONT_FACES[current] || 'agaramond';
      btn.querySelector('.cn-pers-fontmenu__sample').setAttribute('data-font-face', face);
      btn.querySelector('.cn-pers-fontmenu__label').textContent = FONT_SHOPPER[current] || current;
    }
  }

  function pickFont(scope, value) {
    var select = fontField(scope);
    if (!select || select.value === value) {
      closeFontMenus();
      return;
    }
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    closeFontMenus();
  }

  function closeFontMenus(except) {
    document.querySelectorAll('.cn-pers-fontmenu.is-open').forEach(function (menu) {
      if (menu !== except) menu.classList.remove('is-open');
    });
  }

  /* ---------- additional info: two lines, then grow ---------- */

  function autoGrow(el) {
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = (el.scrollHeight + 2) + 'px';
  }

  function polishAdditional(scope) {
    var el = additionalField(scope);
    if (!el || el.tagName !== 'TEXTAREA') return;
    el.rows = ADDITIONAL_ROWS;
    el.classList.add('cn-pers-grow');
    autoGrow(el);
  }

  /* ---------- live preview (single box) ---------- */

  function buildPreview() {
    var wrap = document.createElement('div');
    wrap.className = PREVIEW_CLASS;
    wrap.setAttribute(FIELD_MARK, '1');
    wrap.setAttribute('aria-live', 'polite');

    var eyebrow = document.createElement('p');
    eyebrow.className = 'cn-pers-preview__eyebrow';
    eyebrow.textContent = 'Live preview';

    var panel = document.createElement('div');
    panel.className = 'cn-pers-preview__panel';

    var greeting = document.createElement('p');
    greeting.className = 'cn-pers-preview__greeting';
    greeting.setAttribute('data-line', 'greeting');

    var name = document.createElement('p');
    name.className = 'cn-pers-preview__name';
    name.setAttribute('data-line', 'name');

    var additional = document.createElement('p');
    additional.className = 'cn-pers-preview__additional';
    additional.setAttribute('data-line', 'additional');

    /* Foil reads as a SURFACE, never as text: ink on foil clears 10:1, while
       the brand foil used as text on the cream plate measures 2.4:1. */
    var foilTag = document.createElement('span');
    foilTag.className = 'cn-pers-preview__foil';
    foilTag.setAttribute('aria-hidden', 'true');
    foilTag.textContent = PLATE_FOIL_COPY;

    panel.appendChild(foilTag);
    panel.appendChild(greeting);
    panel.appendChild(name);
    panel.appendChild(additional);
    wrap.appendChild(eyebrow);
    wrap.appendChild(panel);
    return wrap;
  }

  function firstPersField(scope) {
    var order = showGreetingAdditional(scope)
      ? [GREETING_LABEL, NAMES_LABEL, FONT_LABEL, ADDITIONAL_LABEL, GOLD_LABEL]
      : [NAMES_LABEL, FONT_LABEL, GOLD_LABEL];
    for (var i = 0; i < order.length; i++) {
      var el = propField(scope, order[i]);
      var wrap = fieldWrap(el);
      if (wrap) return wrap;
    }
    return null;
  }

  function ensurePreview(scope) {
    if (!namesField(scope)) return;
    if (scope.querySelector('.' + PREVIEW_CLASS)) return;
    var anchor = firstPersField(scope);
    if (!anchor) return;
    /* Greeting and name now live inside the row; anchor on the row itself so
       the plate lands above it instead of inside the flex. */
    anchor = anchor.closest('.cn-pers-fieldrow') || anchor;
    if (!anchor.parentNode) return;
    anchor.parentNode.insertBefore(buildPreview(), anchor);
  }

  function refreshPreview(scope) {
    var root = scope.querySelector('.' + PREVIEW_CLASS);
    if (!root) return;
    var allowGreetingAdditional = showGreetingAdditional(scope);

    var gEl = greetingField(scope);
    var nEl = namesField(scope);
    var fEl = fontField(scope);
    var aEl = additionalField(scope);

    var greeting = gEl && gEl.value ? String(gEl.value).trim() : '';
    var names = nEl && nEl.value ? String(nEl.value).trim() : '';
    var font = fEl && fEl.value ? String(fEl.value).trim() : 'AGaramond Italic';
    var additional = aEl && aEl.value ? String(aEl.value).trim() : '';

    var gLine = root.querySelector('[data-line="greeting"]');
    var nLine = root.querySelector('[data-line="name"]');
    var aLine = root.querySelector('[data-line="additional"]');

    var showGreeting = greeting && greeting.toUpperCase() !== NO_GREETING;
    if (gLine) {
      if (!allowGreetingAdditional) {
        gLine.textContent = '';
        gLine.hidden = true;
        gLine.classList.toggle('is-placeholder', true);
      } else {
        gLine.textContent = showGreeting ? greeting : '';
        gLine.hidden = !showGreeting;
        gLine.classList.toggle('is-placeholder', false);
      }
    }

    if (nLine) {
      nLine.textContent = names || SAMPLE_NAME;
      nLine.classList.toggle('is-placeholder', !names);
      var face = FONT_FACES[font] || 'agaramond';
      nLine.setAttribute('data-font', face);
    }

    var panel = root.querySelector('.cn-pers-preview__panel');
    if (panel) panel.classList.toggle('is-gold', isGoldOn(scope));
    syncFontControl(scope);
    syncGoldTag(scope);

    if (aLine) {
      if (!allowGreetingAdditional) {
        aLine.textContent = '';
        aLine.hidden = true;
        aLine.classList.toggle('is-placeholder', true);
      } else {
        aLine.textContent = additional || SAMPLE_ADDITIONAL;
        aLine.classList.toggle('is-placeholder', !additional);
        aLine.hidden = false;
      }
    }

    fitPreviewName(nLine);
  }

  function fitPreviewName(el) {
    if (!el) return;
    el.style.fontSize = '';
    el.style.whiteSpace = '';
    el.style.overflowWrap = '';
    el.style.minHeight = '';
    var base = parseFloat(window.getComputedStyle(el).fontSize);
    if (!base || !el.clientWidth) return;
    var floor = base * 0.62;
    var size = base;
    el.style.whiteSpace = 'nowrap';
    while (el.scrollWidth > el.clientWidth && size > floor) {
      size -= 1;
      el.style.fontSize = size + 'px';
    }
    if (el.scrollWidth > el.clientWidth) {
      el.style.whiteSpace = 'normal';
      el.style.overflowWrap = 'anywhere';
    }

    /* Bickham's real painted bounds are much taller than its CSS line-height,
       and vary between font engines. Measure the loaded glyph box on this
       exact browser, then reserve only that height plus a small safety cushion.
       A fixed worst-case box made every script preview look unnecessarily airy. */
    if (el.getAttribute('data-font') === 'bickham') {
      el.style.minHeight = '0px';
      var cushion = Math.max(8, Math.ceil(base * 0.2));
      /* Setting min-height can itself change the grid item's scroll height.
         Settle it twice so we reserve against the actual final browser metric,
         not the first, smaller measurement. */
      for (var pass = 0; pass < 2; pass++) {
        el.style.minHeight = (el.scrollHeight + cushion) + 'px';
      }
    }
  }

  /* A selected Adobe face can finish loading after the input's first preview
     pass. Re-measure once font loading settles so a fallback face's smaller
     bounds can never leave the real script glyphs clipped on another device. */
  function refitPreviewAfterFonts(scope) {
    if (!document.fonts || !document.fonts.ready) return;
    document.fonts.ready.then(function () {
      if (readPersState(scope).on) refreshPreview(scope);
    });
  }

  /* ---------- field polish: labels, counters, gold badge ---------- */

  function ensureCounter(input, max) {
    if (!input || input.getAttribute('data-cn-counter') === '1') return;
    input.setAttribute('data-cn-counter', '1');
    input.setAttribute('maxlength', String(max));

    var wrap = fieldWrap(input);
    if (!wrap) return;
    var group = wrap.querySelector('.form__group') || wrap;
    group.classList.add('cn-pers-field--counted');

    var counter = document.createElement('span');
    counter.className = 'cn-pers-counter';
    counter.setAttribute('aria-hidden', 'true');

    function sync() {
      var len = (input.value || '').length;
      counter.textContent = len + '/' + max;
      counter.classList.toggle('is-near', len >= max - 10);
    }

    input.addEventListener('input', sync);
    sync();
    group.appendChild(counter);
  }

  function rewriteLabel(input, text, hint) {
    if (!input) return;
    var wrap = fieldWrap(input);
    if (!wrap) return;
    var label = wrap.querySelector('.form__label');
    if (!label || label.getAttribute('data-cn-label') === '1') return;
    label.setAttribute('data-cn-label', '1');
    var required = label.querySelector('.text-error');
    label.textContent = '';
    label.appendChild(document.createTextNode(text));
    if (required) label.appendChild(required);
    else if (input.hasAttribute('required') || input.getAttribute('aria-required') === 'true') {
      var star = document.createElement('span');
      star.className = 'text-error';
      star.setAttribute('aria-hidden', 'true');
      star.textContent = '*';
      label.appendChild(star);
    }
    if (hint) {
      var note = document.createElement('span');
      note.className = 'cn-pers-hint';
      note.textContent = hint;
      label.parentNode.insertBefore(note, label.nextSibling);
    }
  }

  function isGoldOn(scope) {
    var input = goldField(scope);
    return !!(input && (input.checked || String(input.value || '').toLowerCase() === 'yes'));
  }

  /* Gold foil: the theme's own checkbox, with the price offer rendered as the
     homepage foil rectangle INSIDE the <label>. The tick box (Poetic's
     `label::before`) sits outside the foil, so the control reads as
     "[✓] [ Make it gold foil +₹1,000 ]". No custom toggle JS at all — clicking
     the label is a native checkbox activation, which is why it cannot break. */
  function polishGold(scope) {
    var input = goldField(scope);
    if (!input) return;
    var wrap = fieldWrap(input);
    if (!wrap || wrap.getAttribute('data-cn-gold') === '1') return;
    wrap.setAttribute('data-cn-gold', '1');
    wrap.classList.add('cn-pers-gold');

    /* The block's own "Gold foil" label is redundant next to the new copy, but
       stays in the DOM as the field's accessible name. */
    var label = wrap.querySelector('.form__label');
    if (label) label.classList.add('visually-hidden');

    var visible = wrap.querySelector('.form__group-checkbox label[for]');
    if (visible && !visible.querySelector('.cn-pers-goldtag')) {
      visible.innerHTML = '';
      var tag = document.createElement('span');
      tag.className = 'cn-foil cn-pers-goldtag';
      tag.innerHTML = '<span class="cn-pers-goldtag__copy"></span>' +
        '<span class="cn-pers-goldtag__amount"></span>';
      tag.querySelector('.cn-pers-goldtag__copy').textContent = GOLD_TAG_COPY;
      tag.querySelector('.cn-pers-goldtag__amount').textContent = GOLD_TAG_AMOUNT;
      visible.appendChild(tag);
    }
    syncGoldTag(scope);
  }

  /* Belt and braces on the money path: Poetic's <form-checkbox> is what turns
     checked/unchecked into the "Yes"/"No" line-item value. If it ever fails to
     upgrade, a ticked box would submit "No" — the shopper pays the ₹1,500 fee
     and the foil never reaches production. Normalising here is idempotent. */
  function syncGoldValue(scope) {
    var input = goldField(scope);
    if (!input) return;
    var box = input.closest('form-checkbox');
    var want = input.checked
      ? ((box && box.getAttribute('data-checked')) || 'Yes')
      : ((box && box.getAttribute('data-unchecked')) || 'No');
    if (input.value !== want) input.value = want;
  }

  function syncGoldTag(scope) {
    syncGoldValue(scope);
    var on = isGoldOn(scope);
    (scope || document).querySelectorAll('.cn-pers-gold').forEach(function (wrap) {
      wrap.classList.toggle('is-on', on);
    });
    (scope || document).querySelectorAll('.cn-pers-preview__panel').forEach(function (panel) {
      panel.classList.toggle('is-gold', on);
    });
  }

  function polishFontOptions(scope) {
    var select = fontField(scope);
    if (!select || select.getAttribute('data-cn-font-labels') === '1') return;
    select.setAttribute('data-cn-font-labels', '1');
    Array.prototype.forEach.call(select.options, function (opt) {
      var shopper = FONT_SHOPPER[opt.value];
      if (shopper) opt.textContent = shopper;
    });
  }

  function polishPlaceholders(scope) {
    [namesField(scope), additionalField(scope)].forEach(function (el) {
      if (!el || !el.placeholder) return;
      el.placeholder = String(el.placeholder).replace(/^\s+/, '').replace(/\s+\*$/, '');
    });
  }

  function ensureFeeNote(scope) {
    if (!scope.querySelector('.' + ROW_CLASS)) return;
    var goldWrap = fieldWrap(goldField(scope));
    var host = goldWrap || scope.querySelector('.' + PREVIEW_CLASS);
    if (!host) return;
    var note = scope.querySelector('.cn-pers-fee-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'cn-pers-fee-note';
      if (goldWrap && goldWrap.parentNode) {
        goldWrap.parentNode.insertBefore(note, goldWrap.nextSibling);
      } else if (host.parentNode) {
        host.parentNode.insertBefore(note, host.nextSibling);
      }
    }
    syncFeeNote(scope);
  }

  function syncFeeNote(scope) {
    var note = scope.querySelector('.cn-pers-fee-note');
    if (!note) return;
    if (!readPersState(scope).on) {
      note.hidden = true;
      note.textContent = '';
      return;
    }
    note.hidden = false;
    var gold = goldField(scope);
    var onGold = !!(gold && (gold.checked || String(gold.value || '').toLowerCase() === 'yes'));
    note.textContent = onGold
      ? 'Personalisation fee: ' + FEE_GOLD_LABEL.slice(1) + ' (includes gold foil)'
      : 'Personalisation fee: ' + FEE_LABEL.slice(1);
  }

  function polishFields(scope) {
    rewriteLabel(greetingField(scope), 'Greeting', 'Shown in Garamond above the name');
    rewriteLabel(namesField(scope), 'Name / content');
    rewriteLabel(fontField(scope), 'Font');
    rewriteLabel(additionalField(scope), 'Additional info (optional)');
    polishFontOptions(scope);
    polishPlaceholders(scope);
    polishAdditional(scope);
    ensureCounter(namesField(scope), NAMES_MAX);
    ensureCounter(additionalField(scope), ADDITIONAL_MAX);
    buildFontControl(scope);
    syncFontControl(scope);
    polishGold(scope);
    ensureFeeNote(scope);
  }

  /* Strip empty optional props + Gold foil:No from ATC payloads.
     Poetic's product-form.js appends .product__line_item_property fields onto
     FormData outside the <form>, so disabling inputs is not enough. The
     per-form gate removes the class from excluded Greeting / Additional fields;
     do not make that decision here, because a cart request has no dependable
     association with its originating product form (notably in quick-add). */
  function scrubCartAddBody(body) {
    if (!body) return body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var drop = [];
      body.forEach(function (value, key) {
        if (key === 'properties[' + ADDITIONAL_LABEL + ']' && !String(value || '').trim()) drop.push(key);
        if (key === 'properties[' + GOLD_LABEL + ']' && String(value || '').trim().toLowerCase() !== 'yes') drop.push(key);
      });
      drop.forEach(function (key) { body.delete(key); });
      return body;
    }
    if (typeof body === 'string') {
      try {
        var parsed = JSON.parse(body);
        scrubCartAddBody(parsed);
        return JSON.stringify(parsed);
      } catch (e) {
        return body;
      }
    }
    if (typeof body === 'object') {
      var items = body.items || (body.id ? [body] : null);
      if (!items) return body;
      items.forEach(function (item) {
        if (!item || !item.properties) return;
        if (!String(item.properties[ADDITIONAL_LABEL] || '').trim()) delete item.properties[ADDITIONAL_LABEL];
        if (String(item.properties[GOLD_LABEL] || '').trim().toLowerCase() !== 'yes') delete item.properties[GOLD_LABEL];
      });
    }
    return body;
  }

  function watchPersFormSubmit() {
    /* Kept as a no-op hook name for init(); scrubbing happens in watchCartWrites. */
  }

  /* ---------- cart: keep fee lines in step ---------- */

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(parseCartResponse);
  }

  var DRAWER_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function parseCartResponse(response) {
    return response.json().catch(function () {
      throw new Error('Shopify returned an invalid cart response.');
    }).then(function (payload) {
      if (!response.ok || payload.status || payload.errors) {
        throw new Error(payload.description || payload.message || payload.errors || 'Shopify could not update the cart.');
      }
      return payload;
    });
  }

  function postCart(url, body) {
    body.sections = DRAWER_SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(parseCartResponse);
  }

  function checkoutControls() {
    return document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
  }

  function setIntegrityLock(locked) {
    Array.prototype.forEach.call(checkoutControls(), function (control) {
      if (locked) {
        if (!control.hasAttribute('data-cn-pers-lock')) {
          control.setAttribute('data-cn-pers-lock', control.disabled ? 'disabled' : 'enabled');
        }
        control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
        if (control.tagName === 'A') control.setAttribute('tabindex', '-1');
      } else if (control.hasAttribute('data-cn-pers-lock')) {
        if (control.getAttribute('data-cn-pers-lock') === 'enabled') control.disabled = false;
        control.removeAttribute('data-cn-pers-lock');
        control.removeAttribute('aria-disabled');
        if (control.tagName === 'A') control.removeAttribute('tabindex');
      }
    });
  }

  function showIntegrityError(error) {
    setIntegrityLock(true);
    var message = feeConfig.integrityError || 'The required personalisation fee could not be added. Please try again before checkout.';
    var target = document.getElementById(INTEGRITY_ERROR_ID);
    if (!target) {
      target = document.createElement('p');
      target.id = INTEGRITY_ERROR_ID;
      target.setAttribute('role', 'alert');
      target.style.margin = '1rem 0';
      target.style.color = 'rgb(var(--color-base-text))';
      var checkout = checkoutControls()[0];
      if (checkout && checkout.parentNode) checkout.parentNode.insertBefore(target, checkout);
      else document.body.appendChild(target);
    }
    target.textContent = message;
    if (window.console && console.error) console.error('Personalisation fee reconciliation failed:', error);
  }

  function clearIntegrityError() {
    var target = document.getElementById(INTEGRITY_ERROR_ID);
    if (target) target.remove();
    setIntegrityLock(false);
  }

  function watchIntegrityControls() {
    new MutationObserver(function () {
      if (document.getElementById(INTEGRITY_ERROR_ID)) setIntegrityLock(true);
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', function (event) {
      if (!document.getElementById(INTEGRITY_ERROR_ID)) return;
      if (!event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]')) return;
      event.preventDefault();
      showIntegrityError(new Error('Checkout remains blocked until the fee is reconciled.'));
    }, true);
  }

  function isPersonalised(item) {
    var props = item.properties || {};
    var name = props[NAMES_LABEL];
    return !!(name && String(name).trim());
  }

  function isGoldFoil(item) {
    var props = item.properties || {};
    var v = props[GOLD_LABEL];
    return String(v || '').trim().toLowerCase() === 'yes';
  }

  function entryFromItem(item) {
    var props = item.properties || {};
    return {
      title: item.product_title || item.title,
      greeting: String(props[GREETING_LABEL] || '').trim(),
      names: String(props[NAMES_LABEL] || '').trim(),
      font: String(props[FONT_LABEL] || '').trim(),
      additional: String(props[ADDITIONAL_LABEL] || '').trim(),
      gold: isGoldFoil(item)
    };
  }

  function foilDetail(entries) {
    return entries.map(function (e) {
      var parts = [];
      if (e.greeting && e.greeting.toUpperCase() !== NO_GREETING) parts.push(e.greeting);
      parts.push(e.names);
      if (e.additional) parts.push(e.additional);
      if (e.font) parts.push(e.font);
      if (e.gold) parts.push('Gold foil');
      var detail = parts.join(' · ');
      return entries.length > 1 ? (e.title + ': ' + detail) : detail;
    }).join('  |  ');
  }

  function syncOneFee(existing, variantId, entries) {
    var want = entries.length;
    var wantFor = entries.map(function (e) { return e.title; }).join(', ');
    var wantFoil = foilDetail(entries);
    var have = existing ? existing.quantity : 0;
    var haveFor = (existing && existing.properties && existing.properties[FOR_LABEL]) || '';
    var haveFoil = (existing && existing.properties && existing.properties[FOIL_LABEL]) || '';
    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    if (want === 0) {
      return existing
        ? postCart(changeUrl, { id: existing.key, quantity: 0 })
        : Promise.resolve(null);
    }

    if (!variantId) {
      return Promise.reject(new Error('No personalisation fee product is configured in theme settings.'));
    }

    var properties = {};
    properties[FOR_LABEL] = wantFor;
    if (wantFoil) properties[FOIL_LABEL] = wantFoil;

    if (existing && Number(existing.variant_id) === Number(variantId)) {
      if (want === have && wantFor === haveFor && wantFoil === haveFoil) return Promise.resolve(null);
      return postCart(changeUrl, { id: existing.key, quantity: want, properties: properties });
    }

    var remove = existing
      ? postCart(changeUrl, { id: existing.key, quantity: 0 })
      : Promise.resolve(null);

    return remove.then(function () {
      return postCart(addUrl, { items: [{ id: variantId, quantity: want, properties: properties }] });
    });
  }

  function reconcile() {
    if (busy) return Promise.resolve();
    busy = true;
    setIntegrityLock(true);

    return getCart()
      .then(function (cart) {
        var seen = {};
        var standardEntries = [];
        var goldEntries = [];
        var feeStandard = null;
        var feeGold = null;

        (cart.items || []).forEach(function (item) {
          if (FEE_VARIANT_ID && item.variant_id === FEE_VARIANT_ID) { feeStandard = item; return; }
          if (FEE_GOLD_VARIANT_ID && item.variant_id === FEE_GOLD_VARIANT_ID) { feeGold = item; return; }
          if (!isPersonalised(item)) return;
          if (seen[item.product_id]) return;
          seen[item.product_id] = true;
          var entry = entryFromItem(item);
          if (entry.gold) goldEntries.push(entry);
          else standardEntries.push(entry);
        });

        return syncOneFee(feeStandard, FEE_VARIANT_ID, standardEntries)
          .then(function (a) {
            return syncOneFee(feeGold, FEE_GOLD_VARIANT_ID, goldEntries).then(function (b) {
              return b || a;
            });
          });
      })
      .then(function (changed) {
        if (changed) notifyThemeCartChanged(changed);
        clearIntegrityError();
      })
      .catch(function (error) {
        showIntegrityError(error);
      })
      .then(function () { busy = false; });
  }

  function isCartPage() {
    return window.location.pathname.indexOf('/cart') === 0;
  }

  function notifyThemeCartChanged(state) {
    /* Cart page and drawer are separate UIs — never cross-update.
       - On /cart: reload the page so main-cart-items matches the fee
         reconcile. Do NOT call drawer.renderContents — that always opens
         the drawer and leaves the page stale (seen as “page shows old
         lines, drawer shows the real cart”).
       - Off /cart (PDP / collection / etc.): update the drawer only.
         Do NOT reload — that would navigate the shopper onto /cart. */
    if (isCartPage()) {
      scheduleFeeLineErrorClear();
      window.location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && state && state.sections && typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents(state);
        scheduleFeeLineErrorClear();
      } catch (e) { /* drawer may be mid-teardown; ignore */ }
    }
  }

  function clearFeeLineError() {
    if (!FEE_HANDLE) return;
    var rows = document.querySelectorAll('.cart-item');
    Array.prototype.forEach.call(rows, function (row) {
      if (!row.querySelector('a[href*="/products/' + FEE_HANDLE + '"]')) return;
      var match = String(row.id || '').match(/(\d+)$/);
      if (!match) return;
      ['Line-item-error-' + match[1], 'CartDrawer-LineItemError-' + match[1]].forEach(function (id) {
        var box = document.getElementById(id);
        if (!box) return;
        var text = box.querySelector('.cart-item__error-text');
        if (text) text.innerHTML = '';
        box.classList.add('hidden');
      });
    });
  }

  function pinFeeLineFirst() {
    if (!FEE_HANDLE) return;
    var rows = Array.prototype.slice.call(document.querySelectorAll('.cart-item')).filter(function (row) {
      return !!row.querySelector('a[href*="/products/' + FEE_HANDLE + '"]');
    });
    if (!rows.length) {
      polishCartProperties();
      return;
    }

    /* Pin within each list separately. The cart page and the drawer both render
       .cart-item rows; using a single shared parent (the old v2 rewrite) moved
       the page's fee line into the drawer and left /cart showing only the product
       while totals still counted 2 items. */
    var byParent = [];
    rows.forEach(function (row) {
      var parent = row.parentElement;
      if (!parent) return;
      var group = null;
      for (var i = 0; i < byParent.length; i++) {
        if (byParent[i].parent === parent) { group = byParent[i]; break; }
      }
      if (!group) {
        group = { parent: parent, rows: [] };
        byParent.push(group);
      }
      group.rows.push(row);
    });

    byParent.forEach(function (group) {
      /* Insert gold then standard so Standard ends up first when both exist. */
      group.rows.slice().reverse().forEach(function (row) {
        group.parent.insertBefore(row, group.parent.firstElementChild);
      });
    });

    lockFeeQuantities(rows);
    polishCartProperties();
  }

  function lockFeeQuantities(rows) {
    (rows || []).forEach(function (row) {
      row.classList.add('cn-pers-fee-row');
      Array.prototype.forEach.call(
        row.querySelectorAll('quantity-input, .quantity, .cart-item__quantity'),
        function (el) { el.classList.add('cn-pers-fee-qty'); }
      );
      Array.prototype.forEach.call(
        row.querySelectorAll('input.quantity__input, quantity-input input, .quantity__input'),
        function (input) {
          input.readOnly = true;
          input.setAttribute('aria-readonly', 'true');
          input.tabIndex = -1;
        }
      );
      Array.prototype.forEach.call(
        row.querySelectorAll('.quantity__button, button[name="plus"], button[name="minus"]'),
        function (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.tabIndex = -1;
        }
      );
    });
  }

  function shopperFontLabel(face) {
    return FONT_SHOPPER[face] || face;
  }

  function polishCartProperties() {
    Array.prototype.forEach.call(document.querySelectorAll('.cart-item .product-option'), function (opt) {
      var dt = opt.querySelector('dt');
      var dd = opt.querySelector('dd');
      if (!dt) return;
      var raw = String(dt.textContent || '').replace(/:\s*$/, '').trim();
      var value = dd ? String(dd.textContent || '').trim() : '';

      if (!value || (raw === GOLD_LABEL && value.toLowerCase() === 'no')) {
        opt.hidden = true;
        return;
      }
      opt.hidden = false;

      var nice = CART_PROP_LABELS[raw];
      if (nice) dt.textContent = nice + ':';

      if (dd && raw === FONT_LABEL) {
        dd.textContent = shopperFontLabel(value);
      } else if (dd && raw === GOLD_LABEL && value.toLowerCase() === 'yes') {
        dd.textContent = 'Included';
      } else if (dd && raw === FOIL_LABEL) {
        /* Rewrite face names inside the fulfilment summary for shoppers. */
        var rewritten = value;
        Object.keys(FONT_SHOPPER).forEach(function (face) {
          if (rewritten.indexOf(face) !== -1) {
            rewritten = rewritten.split(face).join(FONT_SHOPPER[face]);
          }
        });
        dd.textContent = rewritten;
      }
    });
  }

  function scheduleFeeLineErrorClear() {
    requestAnimationFrame(function () { clearFeeLineError(); pinFeeLineFirst(); });
    setTimeout(function () { clearFeeLineError(); pinFeeLineFirst(); }, 400);
  }

  /* ---------- watching ---------- */

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;

  function watchCartWrites() {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var isAdd = /\/cart\/add(\.js)?/.test(url);
        var isWrite = CART_WRITE.test(url) && !busy;
        if (isAdd && init && init.body) {
          init = Object.assign({}, init, { body: scrubCartAddBody(init.body) });
        }
        if (isWrite) setIntegrityLock(true);
        return nativeFetch.call(this, input, init).then(function (response) {
          if (isWrite) {
            setTimeout(reconcile, 0);
            scheduleFeeLineErrorClear();
          }
          return response;
        });
      };
    }

    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_WRITE.test(url || '') && !busy) {
        this.addEventListener('load', function () { setTimeout(reconcile, 0); });
      }
      return open.apply(this, arguments);
    };
  }

  function watchPreviewInputs() {
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (
        t.name === 'properties[' + NAMES_LABEL + ']' ||
        t.name === 'properties[' + ADDITIONAL_LABEL + ']'
      ) {
        var scope = t.closest('.product__info-wrapper') || document;
        if (t.name === 'properties[' + ADDITIONAL_LABEL + ']') autoGrow(t);
        refreshPreview(scope);
      }
    });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      var name = (t.name || '').trim().toLowerCase();
      if (
        t.name === 'properties[' + GREETING_LABEL + ']' ||
        t.name === 'properties[' + FONT_LABEL + ']' ||
        t.name === 'properties[' + GOLD_LABEL + ']' ||
        OPTION_NAMES.indexOf(name) > -1
      ) {
        var scope = t.closest('.product__info-wrapper') || document;
        if (OPTION_NAMES.indexOf(name) > -1) {
          gateFields(scope);
          syncFeeNote(scope);
          if (readPersState(scope).on) refreshPreview(scope);
          return;
        }
        refreshPreview(scope);
        if (t.name === 'properties[' + FONT_LABEL + ']') refitPreviewAfterFonts(scope);
        if (t.name === 'properties[' + GOLD_LABEL + ']') syncFeeNote(scope);
      }
    });
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      /* Font: chips and dropdown options both carry data-font. */
      var pick = target.closest('.cn-pers-chip[data-font], .cn-pers-fontmenu__opt[data-font]');
      if (pick) {
        e.preventDefault();
        pickFont(pick.closest('.product__info-wrapper') || document, pick.getAttribute('data-font'));
        return;
      }

      var menuBtn = target.closest('.cn-pers-fontmenu__btn');
      if (menuBtn) {
        e.preventDefault();
        var menu = menuBtn.closest('.cn-pers-fontmenu');
        var open = menu.classList.contains('is-open');
        closeFontMenus();
        if (!open) menu.classList.add('is-open');
        return;
      }
      closeFontMenus();

      /* The gold checkbox toggles natively; just resync after the label click. */
      var goldHost = target.closest('.cn-pers-gold');
      if (goldHost) {
        var scope = goldHost.closest('.product__info-wrapper') || document;
        setTimeout(function () { syncGoldTag(scope); syncFeeNote(scope); }, 0);
      }
    });

    /* Keyboard: arrows move within the chip radiogroup, Escape closes the menu. */
    document.addEventListener('keydown', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (e.key === 'Escape' && target.closest('.cn-pers-fontmenu')) {
        closeFontMenus();
        var btn = target.closest('.cn-pers-fontmenu').querySelector('.cn-pers-fontmenu__btn');
        if (btn) btn.focus();
        return;
      }

      var chip = target.closest('.cn-pers-chip');
      if (!chip) return;
      var dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!dir) return;
      e.preventDefault();
      var all = Array.prototype.slice.call(chip.parentNode.querySelectorAll('.cn-pers-chip'));
      var next = all[(all.indexOf(chip) + dir + all.length) % all.length];
      if (!next) return;
      pickFont(next.closest('.product__info-wrapper') || document, next.getAttribute('data-font'));
      next.focus();
    });

    if (fontMq) {
      var onMq = function () {
        document.querySelectorAll('.product__info-wrapper').forEach(function (scope) {
          if (!fontField(scope)) return;
          buildFontControl(scope);
          syncFontControl(scope);
        });
      };
      if (fontMq.addEventListener) fontMq.addEventListener('change', onMq);
      else if (fontMq.addListener) fontMq.addListener(onMq);
    }

    window.addEventListener('resize', function () {
      document.querySelectorAll('.' + PREVIEW_CLASS + ' [data-line="name"]').forEach(fitPreviewName);
      document.querySelectorAll('.cn-pers-grow').forEach(autoGrow);
    });
  }

  function watchQuickAdd() {
    /* Quick-add fetches the PDP HTML into a dialog that lives on <body>,
       outside <main>. Debounced body observer covers most cases; this poll
       catches slow fetches where the shopper opens options before our first
       mutation pass finishes wiring pills + preview. */
    function poke() {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        ensureRow();
        var ready = document.querySelector('#product-quick-add-dialog .' + ROW_CLASS);
        if (ready || tries >= 40) clearInterval(timer);
      }, 100);
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('quick-add-button')) return;
      poke();
    }, true);
    document.addEventListener('cn:quick-add:loaded', poke);
  }

  function init() {
    ensureRow();
    watchIntegrityControls();
    watchPersFormSubmit();
    /* Observe body — quick-add modal is a direct child of body, not main. */
    new MutationObserver(scheduleEnsureRow).observe(document.body, { childList: true, subtree: true });
  }

  watchCartWrites();
  watchPreviewInputs();
  watchQuickAdd();
  document.addEventListener('shopify:section:load', scheduleEnsureRow);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); reconcile(); pinFeeLineFirst(); });
  } else {
    init();
    reconcile();
    pinFeeLineFirst();
  }
})();
